

class MerchantManagementSystem {
  framework;
  merchantAccountId;
  merchantAccount;
  merchantProduct;


  constructor(_framework) {
    this.framework = _framework;
  }

  setMerchantData(_merchantAccount,_merchantProductArray) {
    this.merchantAccountId = _merchantAccount.merchantAccountId;
    this.merchantAccount = _merchantAccount;
    this.merchantProductArray = _merchantProductArray;
        
    if(this.merchantAccountId !== null) {
      localStorage.setItem("merchantAccountId",this.merchantAccountId);
    }
    if(this.merchantAccount !== null) {
      let merchantAccountString = JSON.stringify(_merchantAccount);
      localStorage.setItem("merchantAccount",merchantAccountString);
    }
    if(this.merchantProductArray !== null) {
      let merchantProductArrayString = JSON.stringify(_merchantProductArray);
      localStorage.setItem("merchantProductArray",merchantProductArrayString);
    }
    
  }

  clear() {
    localStorage.removeItem("merchantAccountId");
    localStorage.removeItem("merchantAccount");
    localStorage.removeItem("merchantProductArray");
  }  

  loadFromStorage() {
    this.merchantAccountId = this.getStoredMerchantAccountId();
    this.merchantAccount  = this.getStoredMerchantAccount();
    this.merchantProduct  = this.getStoredMerchantProductArray();
  }

  getStoredMerchantAccountId() {
    return localStorage.getItem('merchantAccountId');
  }

  getStoredMerchantAccount() {
    return JSON.parse(localStorage.getItem('merchantAccount'));
  }

  getStoredMerchantProductArray() {
    return JSON.parse(localStorage.getItem('merchantProductArray'));
  }

}

export default MerchantManagementSystem;

